/**
 * Public site + API URLs (build-time and runtime via public/config.js).
 */

export const DEFAULT_SITE_URL = "https://dealbeez.com";
// export const DEFAULT_API_URL = "https://apibeezdeals.vercel.app/api/v1";
export const DEFAULT_API_URL = "https://olive-octopus-845596.hostingersite.com/api/v1";
export const DEFAULT_SITE_NAME = "DealBeez";

export function getSiteUrl() {
  if (typeof window !== "undefined" && window.APP_CONFIG?.SITE_URL) {
    return String(window.APP_CONFIG.SITE_URL).replace(/\/$/, "");
  }
  return (
    process.env.REACT_APP_SITE_URL ||
    process.env.REACT_APP_CLIENT_URL ||
    DEFAULT_SITE_URL
  ).replace(/\/$/, "");
}

export function getApiUrl() {
  // Dev: REACT_APP_API_URL in .env.development.local overrides (e.g. local API on :5000)
  if (process.env.NODE_ENV === "development" && process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== "undefined" && window.APP_CONFIG?.API_URL) {
    return window.APP_CONFIG.API_URL;
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  return DEFAULT_API_URL;
}

export function getSiteName() {
  return process.env.REACT_APP_SITE_NAME || DEFAULT_SITE_NAME;
}
